module.exports = __webpack_public_path__ + "img/ali_out_trade_num.00f60c50.png";